import { $isLinkNode } from '@lexical/link';
import { $getSelection, $isRangeSelection } from 'lexical';
import { $getAncestor } from '../../lexicalUtils';
import { $isReferenceCitationNode } from '../../nodes/ReferenceCitationNode';

export const $getLinkUrl = (): string | undefined => {
  const selection = $getSelection();
  if (!$isRangeSelection(selection)) {
    return undefined;
  }
  const nodes = selection.getNodes();

  if (nodes.length === 1) {
    // If there is just one node in selection it will be a TextNode.
    const link = nodes[0].getParents().find($isLinkNode);

    return link?.getURL();
  }

  const firstLink = $isLinkNode(nodes[0]) ? nodes[0] : nodes[0].getParents().find($isLinkNode);
  if (!firstLink) {
    return undefined;
  }
  const onlyOneLinkIsSelected = nodes.every((node) => {
    if ($isLinkNode(node)) {
      return node === firstLink;
    }

    return node.getParents().find($isLinkNode) === firstLink;
  });

  return onlyOneLinkIsSelected ? firstLink.getURL() : undefined;
};

export const $isLinkApplicable = (): boolean => {
  const selection = $getSelection();
  if (!$isRangeSelection(selection)) {
    return false;
  }

  const isReferenceCitation = selection.getNodes().every(
    node => Boolean($getAncestor(node, $isReferenceCitationNode)),
  );

  return !!selection?.getTextContent() && !isReferenceCitation;
};
